// Kiểu dữ liệu Mã xác nhận (khớp BE gate-ad-api: entity ConfirmationCode + response {data}).

export interface ConfirmationCode {
  id: string;
  name: string;
  description?: string | null;
  targetOrgId: string;
  code: string;
  expiredAt: string;
  accessLimit: number;
  accessCount: number;
  status: string; // 'active' | 'disabled'
  batchId?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

/** BE trả mã vừa tạo (rút gọn) sau POST. */
export interface CreatedConfirmationCode {
  id: string;
  code: string;
  expiredAt: string;
  accessLimit: number;
}

export interface CreateConfirmationCodeBody {
  code: string;
  targetOrgId: string;
  expiredAt: string; // ISO
  accessLimit: number;
  description?: string;
  status?: string;
}

export interface UpdateConfirmationCodeBody {
  expiredAt?: string;
  status?: string;
  accessLimit?: number;
  description?: string;
}

export const CONFIRMATION_CODE_STATUS = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
} as const;
